export default __webpack_public_path__ + "static/media/391.eb1bcfbb.jpg";